import _extends from "@babel/runtime/helpers/extends";
import _css from "@emotion/css";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { Component } from 'react';
import ArrowLeftCircleIcon from '@atlaskit/icon/glyph/arrow-left-circle';
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import ConnectedItem from '../ConnectedItem';
var gridSize = gridSizeFn();

var ArrowLeft = function ArrowLeft() {
  return ___EmotionJSX(ArrowLeftCircleIcon, {
    primaryColor: "currentColor",
    secondaryColor: "inherit"
  });
};

var BackItem =
/*#__PURE__*/
function (_Component) {
  _inherits(BackItem, _Component);

  function BackItem() {
    _classCallCheck(this, BackItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(BackItem).apply(this, arguments));
  }

  _createClass(BackItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          beforeProp = _this$props.before,
          text = _this$props.text,
          props = _objectWithoutProperties(_this$props, ["before", "text"]);

      var before = beforeProp;

      if (!before) {
        before = ArrowLeft;
      }

      return ___EmotionJSX("div", {
        css:
        /*#__PURE__*/
        _css({
          marginBottom: gridSize * 2
        }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2Nvbm5lY3RlZC9CYWNrSXRlbS9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5QlciLCJmaWxlIjoiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY29ubmVjdGVkL0JhY2tJdGVtL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBBcnJvd0xlZnRDaXJjbGVJY29uIGZyb20gJ0BhdGxhc2tpdC9pY29uL2dseXBoL2Fycm93LWxlZnQtY2lyY2xlJztcbmltcG9ydCB7IGdyaWRTaXplIGFzIGdyaWRTaXplRm4gfSBmcm9tICdAYXRsYXNraXQvdGhlbWUvY29uc3RhbnRzJztcblxuaW1wb3J0IENvbm5lY3RlZEl0ZW0gZnJvbSAnLi4vQ29ubmVjdGVkSXRlbSc7XG5cbmNvbnN0IGdyaWRTaXplID0gZ3JpZFNpemVGbigpO1xuXG5jb25zdCBBcnJvd0xlZnQgPSAoKSA9PiAoXG4gIDxBcnJvd0xlZnRDaXJjbGVJY29uIHByaW1hcnlDb2xvcj1cImN1cnJlbnRDb2xvclwiIHNlY29uZGFyeUNvbG9yPVwiaW5oZXJpdFwiIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBCYWNrSXRlbSBleHRlbmRzIENvbXBvbmVudCB7XG4gIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgdGV4dDogJ0JhY2snLFxuICB9O1xuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7IGJlZm9yZTogYmVmb3JlUHJvcCwgdGV4dCwgLi4ucHJvcHMgfSA9IHRoaXMucHJvcHM7XG4gICAgbGV0IGJlZm9yZSA9IGJlZm9yZVByb3A7XG4gICAgaWYgKCFiZWZvcmUpIHtcbiAgICAgIGJlZm9yZSA9IEFycm93TGVmdDtcbiAgICB9XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjc3M9e3sgbWFyZ2luQm90dG9tOiBncmlkU2l6ZSAqIDIgfX0+XG4gICAgICAgIDxDb25uZWN0ZWRJdGVtIHsuLi5wcm9wc30gYWZ0ZXI9e251bGx9IGJlZm9yZT17YmVmb3JlfSB0ZXh0PXt0ZXh0fSAvPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuIl19 */")
      }, ___EmotionJSX(ConnectedItem, _extends({}, props, {
        after: null,
        before: before,
        text: text
      })));
    }
  }]);

  return BackItem;
}(Component);

_defineProperty(BackItem, "defaultProps", {
  text: 'Back'
});

export { BackItem as default };